import { render, staticRenderFns } from "./selPolicyModal.vue?vue&type=template&id=82969f56&scoped=true&"
import script from "./selPolicyModal.vue?vue&type=script&lang=js&"
export * from "./selPolicyModal.vue?vue&type=script&lang=js&"
import style0 from "./selPolicyModal.vue?vue&type=style&index=0&id=82969f56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82969f56",
  null
  
)

export default component.exports